import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Home from "./../../assets/images/games-icon/leftbar/home.png";
import Slots from "./../../assets/images/games-icon/leftbar/slots.png";
import Qtech from "./../../assets/images/games-icon/leftbar/qtech.png";
import Sportsbook from "./../../assets/images/games-icon/leftbar/sports.png";
import Roulette from "./../../assets/images/games-icon/leftbar/roulette.png";
import Basketball from "./../../assets/images/games-icon/leftbar/tennis-ball.png";
import Football from "./../../assets/images/games-icon/leftbar/football.png";
import Tennis from "./../../assets/images/games-icon/leftbar/tennis.png";
import Aviator from "./../../assets/images/icons/aeroplane.png";
import HorseRacing from "./../../assets/images/games-icon/leftbar/horse-racing.png";
import GreyhoundRacing from "./../../assets/images/games-icon/leftbar/greyhound-racing.png";
import LiveCasino from "./../../assets/images/games-icon/leftbar/live-casino.png";
import Promotion from "./../../assets/images/games-icon/Promotion.png";
import Support from "./../../assets/images/icons/customer-service.png";
import { t } from "i18next";

const LeftBarSports = () => {
  const navigate = useNavigate();
  const { sportsData, oddsData, showBetSlip } = useSelector(
    (state) => state.sports
  );
  const { isAuth } = useSelector((state) => state.auth);

  const handleEventClick = (event) => {
    navigate(
      `/detail-page/${event?.marketSlug}/${event?.matchid}/${event?.marketid}/${event?.SportId}`
    );
  };

  return (
    <>
      <div className="leftbarSec">
        <ul>
          <li className="games_link">
            <ul>
              <li>
                <div
                  onClick={() => {
                    isAuth ? navigate("/home") : (window.location.href = "/");
                  }}
                >
                  <img src={Home} alt="home" />
                  <span>{t("allGames")}</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/slots-games");
                  }}
                >
                  <img src={Slots} alt="slots" />
                  <span>{t("slotMachines")}</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    isAuth
                      ? navigate("/casino/ezgevo-lobby-poker")
                      : (window.location.href = "/sign-in");
                  }}
                >
                  <img src={Qtech} alt="qtech" />
                  <span>{t("poker")}</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/atlas-lobby");
                  }}
                >
                  <img src={Sportsbook} alt="sportsbook" />
                  <span>{t("sportsbook")}</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    isAuth
                      ? navigate("/casino/ezg-ultimate-roulette")
                      : (window.location.href =
                          "/casino/ezg-ultimate-roulette");
                  }}
                >
                  <img src={Roulette} alt="exchange" />
                  <span>{t("roulette")}</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/atlas-lobby");
                  }}
                >
                  <img src={Basketball} alt="Cricket Icon" />
                  <span>{t("basketball")}</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/atlas-lobby");
                  }}
                >
                  <img src={Football} alt="Soccer Icon" />
                  <span>{t("football")}</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/atlas-lobby");
                  }}
                >
                  <img src={Tennis} alt=" Icon" />
                  <span>{t("tennis")}</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    isAuth
                      ? navigate("/casino/spribe/aviator")
                      : (window.location.href = "/sign-in");
                  }}
                >
                  <img src={Aviator} alt="Home Icon" />
                  <span>{t("aviator")}</span>
                </div>
              </li>
              {/* <li>
                <div
                  onClick={() => {
                    navigate("/atlas-lobby");
                  }}s
                >
                  <img src={HorseRacing} alt="horse racing" />
                  <span>{t("horseRacing")}</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/atlas-lobby");
                  }}
                >
                  <img src={GreyhoundRacing} alt="greyhound racing" />
                  <span>{t("greyhoundRacing")}</span>
                </div>
              </li> */}
              <li className="">
                <div
                  onClick={() => {
                    isAuth
                      ? navigate("/live-casino")
                      : (window.location.href = "/sign-in");
                  }}
                >
                  <img src={LiveCasino} alt="live casino" />
                  <span>{t("liveCasino")}</span>
                </div>
              </li>
              <li className="">
                <div
                  onClick={() => {
                    navigate("/promotion");
                  }}
                >
                  <img src={Promotion} alt="promotion" />
                  <span>{t("promotion")}</span>
                </div>
              </li>
              <li className="">
                <div
                  onClick={() => {
                    navigate("/contactus");
                  }}
                >
                  <img src={Support} alt="support" />
                  <span>{t("support")}</span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
};

export default LeftBarSports;
